import { useFormContext } from 'react-hook-form';
import { useEffect, useRef, useState } from 'react';
import { NetworkDetailsFormValues, SelectedTreeNode } from '../../types';
import NetworkTreeRow from './NetworkTreeRow';

interface NetworkTreeProps {
  removeNetwork: (index: number) => void;
  selectedNode: SelectedTreeNode | null;
  onSelectNode: (node: SelectedTreeNode) => void;
  isHydrated: boolean;
}

function NetworkTree({
  removeNetwork,
  selectedNode,
  onSelectNode,
  isHydrated,
}: NetworkTreeProps) {
  const { watch } = useFormContext<NetworkDetailsFormValues>();

  const networks = watch('network') ?? [];

  const [expandedSet, setExpandedSet] = useState<Set<string>>(new Set());
  const didAutoExpandRef = useRef(false);

  const totalNetworkCount = networks.length;

  const toggleExpand = (id: string) => {
    setExpandedSet((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  useEffect(() => {
    if (didAutoExpandRef.current) return;
    if (!isHydrated) return;

    const firstNetwork = networks[0];
    if (!firstNetwork) return;

    setExpandedSet(new Set([firstNetwork.id]));
    didAutoExpandRef.current = true;
  }, [isHydrated, networks]);

  return (
    <div className="w-[380px] h-full overflow-y-auto border border-gray70 rounded-lg p-2">
      {networks.map((node, networkIndex) => (
        <NetworkTreeRow
          key={node.id}
          networkIndex={networkIndex}
          totalNetworkCount={totalNetworkCount}
          expandedSet={expandedSet}
          setExpandedSet={setExpandedSet}
          toggleExpand={toggleExpand}
          onRemove={() => removeNetwork(networkIndex)}
          selectedNode={selectedNode}
          onSelectNode={onSelectNode}
        />
      ))}
    </div>
  );
}

export default NetworkTree;
